// extracted by mini-css-extract-plugin
export default {"settings":"Settings_settings__cgY5T","info":"Settings_info__RqHVi","link":"Settings_link__s3sC1"};